import { render, staticRenderFns } from "./simStopStartRecord.vue?vue&type=template&id=ec84b106&scoped=true&"
import script from "./simStopStartRecord.vue?vue&type=script&lang=js&"
export * from "./simStopStartRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec84b106",
  null
  
)

export default component.exports